import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchClaimSettlements } from '../data-provider/claim-settlements';
import type {
  ClaimSettlementsResponse,
  GetClaimSettlementsRequestParams,
} from '../data-provider/claim-settlements/api';

export interface UseGetClaimSettlementsParams {
  claimKey: number | undefined;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export const useGetClaimSettlements = ({
  claimKey,
  pageSize = 10,
  sortColumn = 'SettlementSeq',
  sortDirection = 'DESC',
}: UseGetClaimSettlementsParams) => {
  return useInfiniteQuery<ClaimSettlementsResponse>({
    enabled: Boolean(claimKey),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      const params: GetClaimSettlementsRequestParams = {
        claimKey: Number(claimKey),
        pageIndex: Number(pageParam),
        pageSize,
        sortColumn,
        sortDirection,
      };
      return fetchClaimSettlements(params);
    },
    queryKey: ['claims-loss-and-damage-settlements', claimKey, sortColumn, sortDirection],
    select: (data) => {
      const pages = data.pages ?? [];
      const flatSettlements = pages.flatMap((page) => page?.data ?? []);
      const lastPage = pages[pages.length - 1];
      const pageIndex = pages.length;
      return {
        ...data,
        data: flatSettlements,
        flatSettlements,
        pageIndex,
        totalAmount: Number(lastPage?.totalAmount ?? 0),
        totalRows: Number(lastPage?.totalRows ?? 0),
      };
    },
  });
};
